import React from 'react'
import BaseInputs from './baseInputs'
import DateValidInputs from './dateValidInputs'

export default class DateValidItemForm extends React.Component {
  constructor (props, context) {
    super(props, context)

    this.state = {
      id: props.item ? props.item.id : undefined,
      name: props.item ? props.item.name : '',
      latinName: props.item ? props.item.latinName : '',
      code: props.item ? props.item.code : '',
      legacyCode: props.item ? props.item.legacyCode : '',
      validFrom: props.item ? props.item.validFrom : null,
      validTo: props.item ? props.item.validTo : null
    }
  }

  onBaseInputsChange (values) {
    this.setState({ ...values },
      () => this.onChange())
  }

  onDateValidInputsChange (values) {
    this.setState({ ...values },
      () => this.onChange())
  }

  onChange () {
    this.props.onChange({
      id: this.state.id,
      name: this.state.name,
      latinName: this.state.latinName,
      code: this.state.code,
      legacyCode: this.state.legacyCode,
      validFrom: this.state.validFrom,
      validTo: this.state.validTo
    })
  }

  render () {
    const { isReadOnly } = this.props

    return (
      <div>
        <BaseInputs name={this.state.name} latinName={this.state.latinName} code={this.state.code} legacyCode={this.state.legacyCode} isReadOnly={isReadOnly}
          onChange={(values) => this.onBaseInputsChange(values)} />
        <DateValidInputs validFrom={this.state.validFrom} validTo={this.state.validTo} isReadOnly={isReadOnly}
          onChange={(values) => this.onDateValidInputsChange(values)} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/codeLists/dateValidItemForm.js